var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWindowsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.02181 2.29688H7.50911C7.67425 2.29688 7.80827 2.4309 7.80827 2.59603V7.08333C7.80827 7.24847 7.67425 7.38249 7.50911 7.38249H3.02181C2.85668 7.38249 2.72266 7.24847 2.72266 7.08333V2.59603C2.72266 2.4309 2.85668 2.29688 3.02181 2.29688Z",
    fill: "#8E9095"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41797 7.07077V2.59603C8.41797 2.4309 8.55199 2.29688 8.71712 2.29688H13.1919C13.357 2.29688 13.491 2.4309 13.491 2.59603V7.07077C13.491 7.2359 13.357 7.36992 13.1919 7.36992H8.71712C8.55169 7.36992 8.41797 7.2362 8.41797 7.07077Z",
    fill: "#8E9095"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.02181 7.98438H7.50911C7.67425 7.98438 7.80827 8.1184 7.80827 8.28353V12.7708C7.80827 12.936 7.67425 13.07 7.50911 13.07H3.02181C2.85668 13.07 2.72266 12.936 2.72266 12.7708V8.28353C2.72266 8.1184 2.85668 7.98438 3.02181 7.98438Z",
    fill: "#8E9095"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40625 12.7708V8.28353C8.40625 8.1184 8.54027 7.98438 8.7054 7.98438H13.1927C13.3578 7.98438 13.4919 8.1184 13.4919 8.28353V12.7708C13.4919 12.936 13.3578 13.07 13.1927 13.07H8.7054C8.54027 13.07 8.40625 12.936 8.40625 12.7708Z",
    fill: "#8E9095"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowsIcon);
export default __webpack_public_path__ + "static/media/WindowsIcon.aa468f4f6197a580756da184c012a3e0.svg";
export { ForwardRef as ReactComponent };